import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { tr as t } from "@/lib/i18n";

export default function PasswordInput({ className = "field", testid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input data-testid={testid} type={show ? "text" : "password"} className={`${className} pe-14`} {...props} />
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow(!show)} aria-label={show ? t("إخفاء كلمة المرور") : t("إظهار كلمة المرور")}
        className="absolute end-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-lg flex items-center justify-center text-slate-500 hover:text-brand hover:bg-brand-soft transition-colors">
        {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
